<template>
  <section class="animated columns is-mobile" :class="animation">
    <center class="column is-3 is-offset-5 is-flex-desktop-only is-hidden-mobile">
      <div class=" image-circle" >
        <figure class="image">
          <img src="../assets/pic.jpg">
        </figure>
      </div>
    </center>
    <center class="column is-8 is-offset-2 is-hidden-desktop is-hidden-widescreen is-hidden-tablet is-hidden-fullhd">
      <div class=" image-circle" >
        <figure class="image">
          <img src="../assets/pic.jpg">
        </figure>
      </div>
    </center>
  </section>
</template>

<script>
  export default {
    name : "MainImage",
    props : ['animationClass'] ,
    data () {
      return {
        animation : ""
      }
    },
    mounted () {
      this.animation = this.animationClass
    }
  }
</script>

<style lang="scss" scoped>

@import '../../static/_variables.scss';

.image{
  img{
    border-radius: 50%;
  }
}
.image-circle{
  border-radius: 50%;
  border: 5px $border-color solid;
  padding: 0.5em;
}
</style>



// WEBPACK FOOTER //
// src/componests/MainImage.vue